import create from "zustand"

type PaymentModalData = {
	data: any
	type: "CREATE" | "EDIT"
}
export type ModalType<T = any> = {
	open: boolean,
	modalData?: T | null
}

type ModalStoreType = {
	modalPayment: ModalType<PaymentModalData>
	setModalPayment: (payload: ModalType) => void

	modalBalance: ModalType<any>
	setModalBalance: (payload: ModalType) => void

	modalMerchant: ModalType<PaymentModalData>
	setModalMerchant: (payload: ModalType) => void
}

export const useModalStore = create<ModalStoreType>((set) => ({
	modalPayment: { open: false, modalData: null },
	setModalPayment: (payload: ModalType<PaymentModalData>) => set(() => ({ modalPayment: payload })),

	modalBalance: { open: false },
	setModalBalance: (payload: ModalType<any>) => set(() => ({ modalBalance: payload })),

	modalMerchant: { open: false, modalData: null },
	setModalMerchant: (payload: ModalType<PaymentModalData>) => set(() => ({ modalMerchant: payload })),
}))